import _slicedToArray from "/Users/janjelschen/apploft/tln/tln_lottonds_backend/apploft_cloud_react_modules/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";

/**
 * EndPointForm.js
 *
 * Copyright (c) apploft. GmbH
 */
import React from 'react';
import { useForm } from 'react-hook-form';
import Widget from './Widget';
import { mangle } from './Submission';
import { stringMatching } from '../Theme';

function createDefault(value, keys) {
  if (value === undefined || value === null || keys.length === 0) {
    return value;
  }

  return createDefault(value[keys.shift()], keys);
}

function EndPointForm(_ref) {
  var widgetProps = _ref.widgetProps,
      item = _ref.item,
      onSubmit = _ref.onSubmit,
      strings = _ref.strings;
  console.assert(onSubmit, 'form submit handler expected');

  var _useForm = useForm(),
      register = _useForm.register,
      handleSubmit = _useForm.handleSubmit,
      errors = _useForm.errors,
      watch = _useForm.watch,
      control = _useForm.control;

  return React.createElement('form', {
    onSubmit: handleSubmit(onSubmit)
  }, Object.entries(widgetProps).map(function (_ref2) {
    var _ref3 = _slicedToArray(_ref2, 2),
        key = _ref3[0],
        props = _ref3[1];

    var type = props.type,
        properties = props.properties;

    if (type === 'object') {
      return React.createElement('fieldset', {
        key: key
      }, React.createElement('legend', null, key), React.createElement('label', {
        className: 'fieldsetTitle'
      }, stringMatching(strings, key)), Object.entries(properties).map(function (_ref4) {
        var _ref5 = _slicedToArray(_ref4, 2),
            innerKey = _ref5[0],
            p = _ref5[1];

        if (innerKey !== 'data') {
          // Inheriting required from fieldset.
          p.required = props.required;
        } else {
          console.warn('ignoring required data property');
        }

        var name = mangle(key, innerKey);
        var context = {
          fieldset: key,
          properties: properties,
          watch: watch
        };
        return React.createElement(Widget, {
          key: innerKey,
          name: name,
          props: p,
          errors: errors,
          register: register,
          context: context,
          control: control,
          strings: strings,
          defaultValue: createDefault(item, [key, innerKey])
        });
      }));
    }

    return React.createElement(Widget, {
      key: key,
      name: key,
      props: props,
      errors: errors,
      register: register,
      strings: strings,
      defaultValue: createDefault(item, [key])
    });
  }), React.createElement('input', {
    type: 'submit',
    value: stringMatching(strings, 'submit')
  }));
}

export default EndPointForm;